import { Pressable } from 'react-native'
import Animated, {
  interpolateColor,
  useAnimatedStyle,
  useSharedValue,
  withTiming,
} from 'react-native-reanimated'
import Typography from '@ui/typography'
import { leadingNone } from '@ui/typography/styles'
import useAnimatedPress from '@ui/animated/useAnimatedPress'
import { colors } from '@ui/colors'
import cn from '@ui/utils/cn'
import { sliderConfig } from './styles'
import { useEffect } from 'react'

interface Props {
  label: string
  onPress?: () => void
  disabled?: boolean
  active?: boolean
  colorActive?: string
}

export default function SliderSideButton({
  label,
  onPress,
  disabled,
  active,
  colorActive = colors.text,
}: Props) {
  const { animation, onPressIn, onPressOut } = useAnimatedPress()

  const animateActive = useSharedValue(active ? 1 : 0)

  const stylePressedButton = useAnimatedStyle(() => ({
    backgroundColor: interpolateColor(
      animation.value,
      [0, 1],
      [colors.text0, colors.text10]
    ),
  }))

  const stylePressedText = useAnimatedStyle(() => ({
    color: interpolateColor(
      Math.max(animation.value, animateActive.value),
      [0, 1],
      [colors.black25, colorActive]
    ),
  }))

  useEffect(() => {
    animateActive.set(withTiming(active ? 1 : 0, { duration: 200 }))
  }, [active])

  return (
    <Pressable
      hitSlop={sliderConfig.sideButtonHitSlop}
      onPressIn={onPressIn}
      onPressOut={onPressOut}
      onPress={onPress}
      disabled={disabled}
    >
      <Animated.View
        style={stylePressedButton}
        className="min-h-8 shrink-0 items-center justify-center rounded-xl border border-black/10 px-4 py-2.5"
      >
        <Typography
          variant="SM"
          style={stylePressedText}
          className={cn(leadingNone, 'font-text-semibold')}
        >
          {label}
        </Typography>
      </Animated.View>
    </Pressable>
  )
}
